module.exports = __webpack_public_path__ + "img/PayamIbrahim-Zhyngakam.6c4a0133.jpg";